module.exports = __webpack_public_path__ + "static/media/logo500Dark.6df78159.png";